import { useState } from "react";
import { TextField } from "@mui/material";
import styles from "../movein-checklist.module.css";

const FormComments = ({ onSubmitSignatureCommentsData }) => {
  const [comments, setComments] = useState("");

  const handleChange = (event) => {
    const value = event.target.value;
    setComments(value); // update local state
    onSubmitSignatureCommentsData("comments", value); // push to parent
  };

  return (<div className={`${styles.FormGroupFull} FormGroup`}>
    <TextField
      id="outlined-multiline-static"
      label="Comments"
      multiline
      rows={6}
      value={comments}
      onChange={handleChange}
    />
  </div>);
};

export default FormComments;